module.exports = __webpack_public_path__ + "media/images/countrysquared/nz-8865582850402b96121ab23b75c312ea.svg";